function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import DateTimePicker from "react-native-modal-datetime-picker";
import { parseHoursAndMinutes } from "@oui/lib/src/parseHoursAndMinutes";
import { Kind } from "@oui/lib/src/types";
import { Button } from "./Button";
import { IOSDateTimeInputHeader } from "./DateTimeInput";
import { View } from "./View";
import { useI18n } from "../lib/i18n";
import { useSystemColorScheme } from "../styles";
var noopOnInput = function() {};
/**
 * A `ChatInput` variant that allows user to submit a time of day.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-64}
 */ export function ChatInputTimePicker(_param) {
    var _param_onInput = _param.onInput, onInput = _param_onInput === void 0 ? noopOnInput : _param_onInput, props = _object_without_properties(_param, [
        "onInput"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), showPicker = _useState[0], setShowPicker = _useState[1];
    var systemColorScheme = useSystemColorScheme();
    var formatDate = useI18n().formatDate;
    var _useState1 = _sliced_to_array(useState(function() {
        return props.defaultTime ? parseHoursAndMinutes(props.defaultTime) : new Date();
    }), 1), initialDate = _useState1[0];
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            flexGrow: 1,
            justifyContent: 'center'
        },
        children: [
            /*#__PURE__*/ _jsx(Button, {
                alignSelf: "center",
                variant: "text",
                onPress: function() {
                    return setShowPicker(true);
                },
                text: "Choose time"
            }),
            /*#__PURE__*/ _jsx(DateTimePicker, {
                date: initialDate,
                mode: "time",
                customHeaderIOS: function() {
                    return /*#__PURE__*/ _jsx(IOSDateTimeInputHeader, {
                        mode: "time"
                    });
                },
                isDarkModeEnabled: systemColorScheme === 'dark',
                isVisible: showPicker,
                onConfirm: function(date) {
                    var hoursMinutes = formatDate(date, {
                        hour: 'numeric',
                        minute: '2-digit',
                        hourCycle: 'h23'
                    });
                    onInput({
                        kind: Kind.InputTimePicker,
                        props: {
                            time: hoursMinutes
                        }
                    });
                    setShowPicker(false);
                },
                onCancel: function() {
                    return setShowPicker(false);
                }
            })
        ]
    });
}
